
import axios from '../../../helpers/private.axios'



export const deleteDocumentTemplate = ( id ) => {

    return axios.delete(`/api/documents/templates/${id}/delete`);

}